var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more"},[_c('div',{staticClass:"more__wrapper"},[_c('div',{staticClass:"more__trigger"},[_c('SvgIcon',{key:_vm._uid,attrs:{"name":_vm.icon}})],1),_c('div',{staticClass:"more__menu"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }